import { useState } from "react"
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance"
import { AMANAGE_APP_SETTING_API, APP_SETTINGS_API } from "../../../../Utilities/APIs/APIs"
import Form from "../../../Partials/Layouts/Forms/Form"
import ShortTextInput from "../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput"
import ImageInput from "../../../Partials/Layouts/Forms/FormInputs/ImageInput/ImageInput"
import FormSubmitButton from "../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton"
import SwitchInput from "../../../Partials/Layouts/Forms/FormInputs/SwitchInput/SwitchInput"


function CreateAppSettings({

    employee, setShowCreateForm, setShowModal, triggerFetch

}) {

   const [name, setName] = useState('')
   const [isCategoryFeatured, setIsCategoryFeatured] = useState(false)
    const [image, setImage] = useState()
    const axiosInstance = useAxiosInstance()

    async function handleSubmit(e) {
        e.preventDefault()
        const itemData = new FormData()

        itemData.append('name', name)
        itemData.append('isCategoryFeatured', isCategoryFeatured)
        itemData.append('image', image)
    

        const response = await axiosInstance.post(AMANAGE_APP_SETTING_API, itemData)

        if (response) {

            setShowCreateForm(false);
            setShowModal(false);
            triggerFetch()
        }

    }

    return (
        <Form onSubmit={handleSubmit} hasImage>
            <ShortTextInput
                label= "Name"
                placeholder='Enter name'
                value={name}
                setState={setName}

            />
            <ShortTextInput
                label= "is Category Featured"
                placeholder='Enter description'
                value={isCategoryFeatured}
                setState={setIsCategoryFeatured}

            />
             <SwitchInput
                label={'Is Category Featured'}
                toggleSwitch={() => setIsCategoryFeatured(prevState => !prevState)}
                checked={isCategoryFeatured}
            />
            <ImageInput setState={setImage} allowCreateImage>Upload Image</ImageInput>


            <FormSubmitButton text='Create App Settings' />
        </Form>
    )
}

export default CreateAppSettings